const PAGE_TITLE = "Payments";

export { PAGE_TITLE };
